import { useState, type FormEvent } from "react";
import { ApiClientError } from "../api.js";
import { useAuth } from "../auth.js";

export function LoginScreen() {
  const auth = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await auth.login(email, password);
    } catch (reason) {
      setError(
        reason instanceof ApiClientError && reason.code === "LOGIN_RATE_LIMITED"
          ? "Слишком много попыток. Попробуйте позже."
          : "Неверный email или пароль.",
      );
    } finally {
      setSubmitting(false);
    }
  };
  return (
    <main className="login-shell">
      <form className="login-card" onSubmit={(event) => void submit(event)}>
        <div className="brand login-brand">
          <span className="brand-mark">T</span>
          <div>
            <strong>Tandem</strong>
            <small>Image Studio</small>
          </div>
        </div>
        <span className="eyebrow">Внутренний сервис</span>
        <h1>Вход в Image Studio</h1>
        <p>Используйте учётную запись приложения.</p>
        <label>
          Email
          <input
            aria-label="Email"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </label>
        <label>
          Пароль
          <input
            aria-label="Пароль"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </label>
        {error ? (
          <div className="form-error" role="alert">
            {error}
          </div>
        ) : null}
        <button className="primary centered" disabled={submitting}>
          {submitting ? "Проверяем…" : "Войти"}
        </button>
      </form>
    </main>
  );
}
